import { ICustomerOption } from '~/common/types';
import { Flex, Icon, Select, SelectProps, Text } from '@wyz/ui';
import { OptionProps, SingleValueProps, components } from 'react-select';
import { Trans, useI18n } from '~/common/context';
// eslint-disable-next-line @wyz/module/no-relative-import
import './selector.scss';

const customerFilterer = (customer: ICustomerOption, searchQuery: string) => {
  return [customer.label, customer.value, customer.city, customer.zipCode].some(
    (val) =>
      val?.trim().toLowerCase().includes(searchQuery.trim().toLowerCase()),
  );
};
function CustomOption(props: OptionProps<ICustomerOption, false>) {
  return (
    <span
      // @ts-expect-error data-cy is not a valid attr
      data-cy={`${String(props.selectProps['data-cy'])}.${props.data.name}`}
      key={props.innerProps.key}
    >
      <components.Option {...props}>
        <div>
          <Flex alignItems='center' justifyContent='between'>
            <Text heading='xs' color='secondary' weight='semi-bold'>
              {props.data.label}
            </Text>
            {props.isSelected && (
              <Icon
                icon='check-mark-line'
                size={'sm'}
                className='text-primary'
              />
            )}
          </Flex>
          <Text heading='xs' color='secondary-gray'>
            {props.data.city ?? '-'}
          </Text>
        </div>
      </components.Option>
    </span>
  );
}

function CustomSingleValueProps(
  props: SingleValueProps<ICustomerOption, false>,
) {
  return (
    <components.SingleValue
      {...props}
      innerProps={{
        ...props.innerProps,
        // @ts-expect-error data-cy is not a valid attr
        'data-cy': `${String(props.selectProps['data-cy'])}.value`,
      }}
    >
      <div className='d-flex align-items-center space-x-2'>
        <span className='fs-lg'>{props.data.label}</span>
        <span>{'-'}</span>
        <span className='fs-sm'>{props.data.city ?? '?'}</span>
      </div>
    </components.SingleValue>
  );
}

type Props = Pick<
  SelectProps<false, ICustomerOption>,
  'isLoading' | 'isDisabled' | 'value' | 'options' | 'onChange'
>;
function BaseCustomerSelector(props: Props) {
  const { t } = useI18n();

  return (
    <Flex alignItems='center'>
      <Select<false, ICustomerOption>
        placeholder={
          <Trans i18nKey='app.common.datatable.filter.select.placeholder' />
        }
        size='md'
        name=''
        className={'me-2 customer-selector'}
        components={{
          Option: CustomOption,
          SingleValue: CustomSingleValueProps,
        }}
        filterOption={(option, inputValue) =>
          Boolean(customerFilterer(option.data, inputValue))
        }
        data-cy={'customer'}
        limit={20}
        showCount={(total) =>
          t('app.common.datatable.pagination.showing_result', { total })
        }
        isClearable
        {...props}
      />
    </Flex>
  );
}

export default BaseCustomerSelector;
